<template>
  <div class="video-seminar-wrap">
    <bread-crumb :bread-list="breadList" />
    <div class="video-seminar-content">
      <div class="title-wrap">
        <i class="iconfont icon-tongyongbiaotiicon"></i>
        <span class="title-text">{{this.$route.query.collectTitle}}</span>
      </div>
      <div class="search-wrap">
        <div class="search-show-wrap">
          <el-input
            class="search-input"
            size="small"
            placeholder="请输入视频标题"
            v-model="searchBannerName"
            @keyup.enter.native="getList">
          <i slot="suffix"
            class="iconfont icon-search"
            @click="getList"></i>
          </el-input>
        </div>
        <el-button
          size="small"
          @click="clickAddVideo">新增视频</el-button>
      </div>
      <div class="table-wrap">
        <el-table
          :data="dataList"
          stripe
          v-loading="loading"
          style="width: 100%">
          <el-table-column
            min-width="60px"
            label="序号">
            <template slot-scope="scope">
              <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="250px"
            label="视频名称">
            <template slot-scope="scope">
              <div class="image_title">
                <el-image
                  v-if="scope.row.coverPicture"
                  class="cover-picture"
                  :src="'/ms-hoc-video/v1/image/download?fileName='+ scope.row.coverPicture">
                </el-image>
                <div class="text_title">
                  <span class="image_text">{{ scope.row.bannerTitle }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="url"
            min-width="180px"
            label="URL">
          </el-table-column>
          <el-table-column
            label="上线时间"
            min-width="125px"
            >
            <template slot-scope="scope">
              <span>
                {{ scope.row.addedTime|formatDate }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            min-width="140px">
            <template slot-scope="scope">
              <span>
                {{ scope.row.createTime|formatDate }}
              </span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="排序" width="90">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="status-on">
                <i class="iconfont icon-paixushang icon-off" v-if="scope.row.noMoveUp"></i>
                <i class="iconfont icon-paixushang icon-on" v-else @click="clickMoveUp(scope.row.bannerId)"></i>
                <i class="iconfont icon-paixuxia icon-off" v-if="scope.row.noMoveDown"></i>
                <i class="iconfont icon-paixuxia icon-on" v-else @click="clickMoveDown(scope.row.bannerId)"></i>
              </div>
              <div v-else class="status-off">
                <i class="iconfont icon-paixushang"></i>
                <i class="iconfont icon-paixuxia"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="135">
            <template slot-scope="scope">
              <div v-if="scope.row.status">
                <span @click="clickOffline(scope.row.bannerId)" class="link-btn">下线</span>
              </div>
              <div v-else>
                <span @click="clickOnLine(scope.row.bannerId)" class="link-btn">上线</span>
                <span @click="clickEditVideo(scope.row.bannerId)" class="link-btn">编辑</span>
                <span @click="clickDeleteVideo(scope.row.bannerId)" class="link-btn">删除</span>
              </div>
            </template>
          </el-table-column>
          <div slot="empty" class="table-none">
              <div>
                <svg-icon icon-class="none1" />
              </div>
              <span>暂无数据</span>
          </div>
        </el-table>
      </div>
      <div class="pagination-wrap">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync="page.current"
            :page-size="page.pageSize"
            :total="page.total"
            @current-change="changePage">
          </el-pagination>
      </div>
    </div>
    <message-box
      :dialog-visible="dialogVisible"
      :id="bannerId"
      warning-text="确认将此视频删除？"
      @handleConfirm="handleConfirm"
      @handleClose="handleClose" />
  </div>
</template>
<script>
import MessageBox from '@/components/MessageBox'
import { postBannerList, deleteBanner, postDismountedBanner, postVideoSetShelfBanner, getBannerMoveUp, getBannerMoveDown } from '@/api/banner'
export default {
    name: 'videoManagement',
    components: {
        MessageBox
    },
    data () {
        return {
            breadList: [{ label: '内容管理' }, { label: '视频集', path: '/content/videoSet' }],
            searchBannerName: '',
            dataList: [],
            loading: false,
            page: {
                current: 1,
                total: 1,
                pageSize: 10,
                order: ''
            },
            dialogVisible: false,
            bannerId: ''
        }
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    },
    created () {
        this.breadList.push({ label: this.$route.query.collectTitle })
        this.getList()
    },
    methods: {
        async getList () {
            let params = {
                title: '',
                isUsed: '',
                uploader: '',
                createTimeStart: '',
                createTimeEnd: '',
                addedTimeStart: '',
                addedTimeEnd: '',
                doctorName: '',
                size: this.page.pageSize,
                current: this.page.current,
                bannerTitle: this.searchBannerName,
                collectId: this.$route.query.collectId
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postBannerList(params)
            if (results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    if (results[0].priorityLevel !== 0 && this.page.current === 1) {
                        this.$set(results[0], 'noMoveUp', true)
                    }
                    if (results[i].priorityLevel === 1) {
                        this.$set(results[i], 'noMoveDown', true)
                    }
                }
                this.dataList = results
                this.page.total = total
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.getList()
                }
            }
            this.loading = false
        },
        clickAddVideo () {
            this.$router.push({ path: '/content/videoSet/edit/addVideo', query: { collectId: this.$route.query.collectId, collectTitle: this.$route.query.collectTitle } })
        },
        async clickMoveUp (bannerId) {
            const { state } = await getBannerMoveUp(bannerId)
            if (state === 200) {
                this.getList(this.page.current)
            }
        },
        async clickMoveDown (bannerId) {
            const { state } = await getBannerMoveDown(bannerId)
            if (state === 200) {
                this.getList(this.page.current)
            }
        },
        async clickOffline (bannerId) {
            this.loading = true
            const { results } = await postDismountedBanner(bannerId)
            if (results === 'successed') {
                this.$message({
                    message: '视频下线成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.getList(this.page.current)
            }
        },
        async clickOnLine (bannerId) {
            this.loading = true
            const { results } = await postVideoSetShelfBanner(bannerId)
            if (results === 'successed') {
                this.$message({
                    message: '视频上线成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.getList(this.page.current)
            } else if (results === 'failed') {
                this.$message.error('上线失败')
            }
        },
        clickEditVideo (bannerId) {
            this.$router.push({ path: '/content/videoSet/edit/addVideo', query: { collectId: this.$route.query.collectId, collectTitle: this.$route.query.collectTitle, bannerId: bannerId } })
        },
        clickDeleteVideo (bannerId) {
            this.bannerId = bannerId
            this.dialogVisible = true
        },
        changePage (value) {
            this.page.current = value
            this.getList()
        },
        handleConfirm () {
            this.loading = true
            this.dialogVisible = false
            this.handleDeleteBanner()
        },
        handleClose () {
            this.dialogVisible = false
        },
        async handleDeleteBanner () {
            const { state } = await deleteBanner(this.bannerId)
            if (state === 200) {
                this.$message({
                    message: '删除banner成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.getList(this.page.current)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.video-seminar-wrap {
  .video-seminar-content {
    margin: 20px;
    padding: 20px 20px 0 20px;
    min-height: 600px;
    overflow: auto;
    box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
    background: #fff;
    .title-wrap {
      padding-bottom: 20px;
      height: 16px;
      line-height: 16px;
      font-size: 0;
      .icon-tongyongbiaotiicon {
        vertical-align: middle;
        color: $color-primary;
        font-size: 16px;
      }
      .title-text {
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
        font-size: 14px;
        color: #333333;
      }
    }
    .search-wrap {
      display: flex;
      justify-content: space-between;
      .search-show-wrap {
        display: flex;
      }
      .more-search {
        font-size: 0;
        color: #666;
        padding-left: 10px;
        cursor: pointer;
      }
      .more-search-text {
        font-size: 14px;
        line-height: 32px;
        padding-right: 3px;
      }
      .icon-drop_down {
        display: inline-block;
        font-size: 12px;
        color: #999;
        transition: transform 0.3s;
        transform: rotateZ(180deg);
        &.is-reverse {
            transform: rotateZ(0deg);
        }
      }
    }
    .table-wrap {
      margin-top: 20px;
      .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
          font-size: 100px;
        }
        span {
          line-height: 14px;
        }
      }
      .link-btn {
        color: $a-link;
        cursor: pointer;
        font-size: 12px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-right: 1px solid $a-link;
        margin-right: 6px;
        padding-right: 6px;
        &:last-child {
          border-right: none;
          margin-right: 0;
          padding-right: 0;
        }
      }
      .cover-picture {
        width: 70px;
        height: 70px;
        .image-slot {
          .el-icon-picture-outline {
            font-size: 70px;
          }
        }
      }

      .image_title {
        display: flex;
        align-content: center;
        .cover-picture {
          width: 70px;
          height: 70px;
        }
        .text_title {
          margin-left: 14px;
          height: 70px;
          width: 144px;
          display: flex;
          align-items: center;
          .image_text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            line-height: 18px;
            overflow: hidden;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }

      .status-warp {
        line-height: 12px;
        .el-badge {
          height: 10px;
          .el-badge__content {
            width: 6px;
            height: 6px;
          }
          .el-badge__content--success {
            background: #4acfb1;
          }
          .el-badge__content--info {
            background: #cccccc;
          }
        }
      }

      .status-on {
        .icon-off {
          color: #ccc;
        }
        .icon-on {
          cursor: pointer;
          color: #3b8fd9;
        }
        .icon-paixuxia {
          font-size: 16px;
        }
        .icon-paixushang {
          font-size: 16px;
          margin-right: 20px;
        }
      }
      .status-off {
        .icon-paixuxia {
          font-size: 16px;
          color: #ccc;
        }
        .icon-paixushang {
          font-size: 16px;
          color: #ccc;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
